import Image from "next/image";

export const TrustedLogos = () => (
  <div className="absolute bottom-[6%] flex w-full flex-col items-center justify-center gap-4">
    <p className="text-sm font-medium text-gray-400">Trusted by teams at</p>
    <div className="z-50 grid grid-cols-3 items-center justify-items-center gap-5 invert">
      <Image src="/logos/tula.svg" alt="tula-logo" width={58} height={29} />
      <Image
        src="/logos/jonesroad.svg"
        alt="jonesroad-logo"
        width={128}
        height={20}
      />
      <Image src="/logos/mills.svg" alt="mills-logo" width={61} height={25} />
      <Image
        src="/logos/gorillamind.svg"
        alt="gorillamind-logo"
        width={82}
        height={25}
      />
      <Image
        src="/logos/firstandbeauty.svg"
        alt="firstandbeauty-logo"
        width={120}
        height={27}
      />
      <Image src="/logos/gensee.svg" alt="gensee-logo" width={50} height={31} />
    </div>
  </div>
);
